import React from 'react';
import { Table } from 'semantic-ui-react';
import localization from '../../../../locales/localization';

export default class EditableIzdatnicaHeaderCells extends React.Component {
    render() {
        return (
            <React.Fragment>
                <Table.HeaderCell>{localization.artikl.kategorija}</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.common.kolicina}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.izdatnice.maksimalnaKolicina}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="center">{localization.izdatnice.jedinicnaNabavnaCijena}</Table.HeaderCell>
                <Table.HeaderCell textAlign="center" collapsing>
                    {localization.izdatnice.nabavnaCijena}
                </Table.HeaderCell>
            </React.Fragment>
        );
    }
}
